import { useMemo, useState } from 'react';

import { useGetFluxStatusQuery } from 'services/api/products/flux';

export default function useFluxStatus() {
  const { data } = useGetFluxStatusQuery();
  const fluxStatusData = useMemo(() => data?.data || [], [data]);

  const [scenarios, setScenarios] = useState<string[]>([]);
  const [acomphDates, setAcomphDates] = useState<string[]>([]);
  const [forecastDates, setForecastDates] = useState<string[]>([]);

  const clearFilters = () => {
    setScenarios([]);
    setAcomphDates([]);
    setForecastDates([]);
  };

  const scenarioOptions = useMemo(() => (
    fluxStatusData.map((item) => item.cenario)
      .filter((value, index, self) => self.indexOf(value) === index)
  ), [fluxStatusData]);

  const acomphDateOptions = useMemo(() => (
    fluxStatusData.map((item) => item.data_acomph)
      .filter((value, index, self) => self.indexOf(value) === index)
  ), [fluxStatusData]);

  const forecastDateOptions = useMemo(() => (
    fluxStatusData.map((item) => item.data_previsao)
      .filter((value, index, self) => self.indexOf(value) === index)
  ), [fluxStatusData]);

  const filteredItems = useMemo(() => (
    fluxStatusData.filter((item) => (
      (scenarios.length === 0 || scenarios.includes(item.cenario))
      && (acomphDates.length === 0 || acomphDates.includes(item.data_acomph))
      && (forecastDates.length === 0 || forecastDates.includes(item.data_previsao))
    ))
  ), [scenarios, acomphDates, forecastDates, fluxStatusData]);

  return {
    scenarios,
    acomphDates,
    forecastDates,
    setScenarios,
    setAcomphDates,
    setForecastDates,
    clearFilters,
    scenarioOptions,
    acomphDateOptions,
    forecastDateOptions,
    filteredItems,
  };
}
